<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright2">Published by<br/> Grub Street Publishing<br/> 4 Rainham Close<br/> London<br/> SW11 6SS</p>
<p class="copyright">Copyright © Grub Street 2011<br/> Copyright text © Andy Saunders 2011</p>
<p class="copyright"><span class="bold">British Library Cataloguing in Publication Data</span></p>
<p class="copyright">Saunders, Andy.</p>
<p class="copyright1">Finding the fallen : outstanding aircrew mysteries from the <br/>First World War to Desert Storm investigated and solved. <br/>1. Missing in action–Case studies. 2. Airmen–Biography. <br/>3. Aircraft accidents–Investigation--History–20th century. <br/>I. Title<br/>358.4'1338'0922-dc22<br/><br/> <span class="bold">ISBN-13: 9781908117106</span><br/><span class="bold">ePUB ISBN: 9781909166462</span></p>
<p class="copyright">All rights reserved. No part of this publication may be reproduced, <br/>stored in a retrieval system, or transmitted in any form or by any <br/>means electronic, mechanical, photocopying, recording, or <br/>otherwise, without the prior permission of the copyright owner.</p>
<p class="copyright">Design by Roy Platten, Eclipse, Hemel Hempstead<br/><a href="http://roy.eclipse@btopenworld.com" target="_blank">roy.eclipse@btopenworld.com</a></p>
<p class="copyright">Printed and bound by MPG Ltd, Bodmin, Cornwall</p>
<p class="copyright">Grub Street Publishing uses only FSC<br/>(Forest Stewardship Council) paper for its books</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?310f2376